module.exports = __webpack_public_path__ + "static/media/hw_n_46.154ed1bc.flv";